import { Servicio as c } from "../EditPanel/Servicio";
import { conLanding } from "../Models/Landing";

export default class Servicio extends c {
    con = conLanding();
    getDataSave2 = (): any => {
        const a = this.getDataSave();
        return { ...a, ...this.props.props };
    }
}